import React, { Suspense } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { OrbitControls, useGLTF, Environment, Html, useProgress } from "@react-three/drei";
import { Link } from "react-router-dom";
import "./hero.css";

const SHIP_MODEL_URL = process.env.PUBLIC_URL + "/modals/container_ship.glb";

// شاشة تحميل
function Loader() {
  const { progress } = useProgress();
  return (
    <Html center>
      <div className="text-center text-white">
        <div className="spinner-border text-primary mb-3" role="status"></div>
        <div>{progress.toFixed(0)}%</div>
      </div>
    </Html>
  );
}

function ShipScene() {
  const ship = useGLTF(SHIP_MODEL_URL);

  useFrame(({ clock }) => {
    const t = clock.getElapsedTime();
    if (ship.scene) {
      const baseY = -0.9;
      const waveAmplitude = 0.1;

      ship.scene.position.y = baseY + Math.sin(t * 3) * waveAmplitude;
      ship.scene.position.z -= 0.1;
      if (ship.scene.position.z < -120) ship.scene.position.z = 120;

      ship.scene.rotation.y = Math.sin(t / 3) * 0.08;
      ship.scene.rotation.x = Math.sin(t / 5) * 0.02;
    }
  });

  return (
    <>
      <ambientLight intensity={0.8} />
      <directionalLight position={[5, 10, 5]} intensity={1} />

      {/* السفينة */}
      <primitive object={ship.scene} scale={1.2} position={[0, -0.9, 80]} />

      {/* البحر */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -1, 0]}>
        <planeGeometry args={[500, 500, 128, 128]} />
        <meshStandardMaterial
          color="#0b74a1"
          metalness={0.3}
          roughness={0.4}
          opacity={0.9}
          transparent
          side={2}
        />
      </mesh>
    </>
  );
}

export default function HeroThree({t}) {
  return (
    <section className="hero-3d-section position-relative  ">
      <div className="three-canvas-wrapper rounded-0 ">
        <Canvas camera={{ position: [220, 0, 150], fov: 10 }}>
          <Suspense fallback={<Loader />}>
            <ShipScene />
            <Environment preset="sunset" />
          </Suspense>
          <OrbitControls enablePan={false} enableZoom={false} />
        </Canvas>

       

       
      </div>
    </section>
  );
}
